import { useEffect, useState } from 'react';
import FamilyTogether from './img/FamilyTogether.avif';
import HappyFamily from './img/PHOTO-2026-03-04-12-18-22.jpg';
import Family from './img/Family.avif';
import FatherSon from './img/FatherSon.avif';
import IkusasalethuGroupLogo from './img/IkusasalethuGroupLogo.jpg';
import ServiLogo2025 from './img/Servi Logo 2025.png';
import './App.css';
import AdminPage from './AdminPage';

function App() {
  const [isAdminAuthed, setIsAdminAuthed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const faviconLink =
      document.querySelector("link[rel='icon']") || document.createElement('link');
    faviconLink.setAttribute('rel', 'icon');
    faviconLink.setAttribute('href', IkusasalethuGroupLogo);
    if (!faviconLink.parentNode) {
      document.head.appendChild(faviconLink);
    }

    const elements = document.querySelectorAll('.reveal');

    if (!('IntersectionObserver' in window)) {
      elements.forEach((el) => el.classList.add('reveal--visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal--visible');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.18,
        rootMargin: '0px 0px -40px 0px',
      }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const isAdminRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return <AdminPage isAuthed={isAdminAuthed} onAuthed={() => setIsAdminAuthed(true)} />;
  }

  const toggleMobileMenu = () => setIsMobileMenuOpen((open) => !open);

  const handleQuoteSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const fullName = formData.get('fullName') || '';
    const email = formData.get('email') || '';
    const mobile = formData.get('mobile') || '';
    const dependants = formData.get('dependants') || '';
    const plan = formData.get('plan') || '';

    const lines = [
      `Full name: ${fullName}`,
      `Email address: ${email}`,
      `Mobile number: ${mobile}`,
      `Number of dependants: ${dependants}`,
      `Preferred plan: ${plan}`,
    ];

    const body = encodeURIComponent(lines.join('\n'));
    const subject = encodeURIComponent('Ikusasalethu Group – Funeral cover quote request');

    window.location.href = `mailto:info@ikusasalethugroup.co.za?subject=${subject}&body=${body}`;
  };

  return (
    <div className="site-root">
      <header className="top-bar">
        <div className="container top-bar__inner">
          <div className="top-bar__brand">
            <div className="logo-mark">
              <img
                src={IkusasalethuGroupLogo}
                alt="Ikusasalethu Group logo"
                className="logo-mark__img"
              />
            </div>
            <div className="top-bar__brand-text">
              <span className="brand-name">Ikusasalethu Group</span>
              <span className="brand-sub">A product of Servi Contact (FSP)</span>
            </div>
          </div>

          <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>

          <nav className={`top-bar__nav ${isMobileMenuOpen ? 'top-bar__nav--open' : ''}`}>
            <a href="#plans" onClick={toggleMobileMenu}>
              Plans
            </a>
            <a href="#about" onClick={toggleMobileMenu}>
              About
            </a>
            <a href="#why" onClick={toggleMobileMenu}>
              Why Choose Us
            </a>
            <a href="#how-it-works" onClick={toggleMobileMenu}>
              How It Works
            </a>
            <a href="#contact" onClick={toggleMobileMenu}>
              Contact
            </a>
          </nav>
        </div>
      </header>

      <main>
        {/* HERO */}
        <section className="hero reveal" id="quote">
          <div className="container hero__grid">
            <div className="hero__content">
              <p className="eyebrow">Servi Contact · Registered Financial Services Provider</p>
              <h1>Funeral Cover Starting From R39</h1>
              <p className="hero__subtitle">
                Protect your loved ones with reliable, structured funeral cover backed by a
                registered Financial Services Provider.
              </p>
              <div className="hero__ctas">
                <a href="#quote" className="btn btn--primary">
                  Get Covered Today
                </a>
                <a href="#plans" className="btn btn--ghost">
                  View Plans
                </a>
              </div>
              <ul className="hero__points">
                <li>Flexible monthly premiums to suit your budget</li>
                <li>Structured cover from R10,000 to R20,000</li>
                <li>Administered by Servi Contact (Registered FSP)</li>
              </ul>
              <div className="hero-image-strip">
                <div className="hero-image-strip__item">
                  <img src={FamilyTogether} alt="Family spending time together" />
                </div>
              </div>
            </div>
            <div className="hero__panel">
              <div className="hero-card">
                <h2>Request a quote.</h2>
                <p>Share your details and a Servi Contact consultant will contact you to guide you through your options.</p>
                <form className="hero-form" id="hero-quote-form" onSubmit={handleQuoteSubmit}>
                  <div className="field">
                    <label htmlFor="hero-name">Full Name</label>
                    <input id="hero-name" name="fullName" type="text" placeholder="Enter your full name" />
                  </div>
                  <div className="field">
                    <label htmlFor="hero-email">Email Address</label>
                    <input id="hero-email" name="email" type="email" placeholder="you@example.com" />
                  </div>
                  <div className="field">
                    <label htmlFor="hero-phone">Mobile Number</label>
                    <input id="hero-phone" name="mobile" type="tel" placeholder="0XX XXX XXXX" />
                  </div>
                  <div className="field">
                    <label htmlFor="hero-dependants">Number of Dependants</label>
                    <input id="hero-dependants" name="dependants" type="number" min="0" placeholder="e.g. 3" />
                  </div>
                  <div className="field">
                    <label htmlFor="hero-plan">Preferred Plan</label>
                    <select id="hero-plan" name="plan" defaultValue="">
                      <option value="">Select an option</option>
                      <option>Plan 1 – R79 p/m · R10,000 cover</option>
                      <option>Plan 2 – R99 p/m · R15,000 cover</option>
                      <option>Plan 3 – R115 p/m · R20,000 cover</option>
                    </select>
                  </div>
                  <button type="submit" className="btn btn--primary btn--full">
                    Get a Free Quote
                  </button>
                  <p className="form-hint">
                    By submitting this form, you consent to being contacted by Servi Contact in relation to Ikusasalethu Group funeral cover.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* PLANS */}
        <section className="section reveal" id="plans">
          <div className="container">
            <header className="section__header">
              <p className="eyebrow">Our Plans</p>
              <h2>Structured funeral cover options</h2>
              <p className="section__lead">
                Choose a plan that fits your needs today, with the confidence of an FSP-backed
                financial product.
              </p>
            </header>

            <div className="plans-grid">
              <article className="plan-card">
                <h3>Plan 1</h3>
                <p className="plan-card__price">
                  R79<span>/month</span>
                </p>
                <p className="plan-card__cover">R10,000 cover</p>
                {/* <ul className="plan-card__list">
                  <li>Immediate accidental death cover (after first premium)</li>
                  <li>Natural death cover after 3-month waiting period</li>
                  <li>Individual cover</li>
                </ul> */}
                <button className="btn btn--ghost btn--full">Enquire about Plan 1</button>
              </article>

              <article className="plan-card plan-card--featured">
                <div className="plan-card__tag">Most Popular</div>
                <h3>Plan 2</h3>
                <p className="plan-card__price">
                  R99<span>/month</span>
                </p>
                <p className="plan-card__cover">R15,000 cover</p>
                {/* <ul className="plan-card__list">
                  <li>Immediate accidental death cover (after first premium)</li>
                  <li>Natural death cover after 3-month waiting period</li>
                  <li>Balanced monthly premium and benefit</li>
                </ul> */}
                <button className="btn btn--primary btn--full">Choose Plan 2</button>
              </article>

              <article className="plan-card">
                <h3>Plan 3</h3>
                <p className="plan-card__price">
                  R115<span>/month</span>
                </p>
                <p className="plan-card__cover">R20,000 cover</p>
                {/* <ul className="plan-card__list">
                  <li>Immediate accidental death cover (after first premium)</li>
                  <li>Natural death cover after 3-month waiting period</li>
                  <li>Higher cover for greater peace of mind</li>
                </ul> */}
                <button className="btn btn--ghost btn--full">Enquire about Plan 3</button>
              </article>
            </div>

            <p className="plans__fine-print">
              *Pricing, benefits and product details are subject to change and final confirmation
              by Servi Contact and the appointed underwriter.
            </p>
          </div>
        </section>

        {/* ABOUT */}
        <section className="section section--alt reveal" id="about">
          <div className="container about-grid">
            <div>
              <header className="section__header section__header--left">
                <p className="eyebrow">About Ikusasalethu Group</p>
                <h2>Funeral cover backed by a registered FSP</h2>
              </header>
              <p>
                Ikusasalethu Group is a funeral cover product proudly owned and managed by{' '}
                <strong>Servi Contact</strong>.
              </p>
              <p>
                Servi Contact is a registered Financial Services Provider (FSP) operating in South
                Africa. Our mission is to provide affordable, accessible financial protection
                products to everyday South Africans.
              </p>
              <p>
                This product forms part of our growing portfolio of structured financial solutions
                designed to protect families when it matters most.
              </p>
              <div className="about-note">
                <p>
                  Backed by a registered Financial Services Provider, Ikusasalethu Group goes beyond
                  standard funeral cover to deliver a robust, structured financial solution for you
                  and your family.
                </p>
              </div>
            </div>
            <div className="about-panel">
              <div className="about-image">
                <img
                  src={HappyFamily}
                  alt="Happy family together"
                  style={{ borderRadius: 'var(--radius-lg)', width: '100%' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* WHY CHOOSE US */}
        <section className="section reveal" id="why">
          <div className="container">
            <header className="section__header">
              <p className="eyebrow">Why Choose Us</p>
              <h2>Why choose Ikusasalethu Group</h2>
              <p className="section__lead">
                Built as a structured financial product under a registered FSP – not a once-off,
                informal funeral scheme.
              </p>
            </header>

            <div className="features-grid">
              <article className="feature">
                <h3>Affordable monthly premiums</h3>
                <p>Clear, entry-level pricing from R79 per month with transparent cover amounts.</p>
              </article>
              <article className="feature">
                <h3>Structured cover options</h3>
                <p>Defined benefit levels from R10,000 to R20,000 to match your family&rsquo;s needs.</p>
              </article>
              <article className="feature">
                <h3>Backed by a registered FSP</h3>
                <p>
                  Owned and administered by Servi Contact, a registered Financial Services Provider
                  in South Africa.
                </p>
              </article>
              <article className="feature">
                <h3>Professional administration</h3>
                <p>Ongoing support and policy administration from a specialist financial services team.</p>
              </article>
            </div>

            <div className="why-images">
              <div className="why-image">
                <img src={Family} alt="Extended family together" />
              </div>
              <div className="why-image">
                <img src={FatherSon} alt="Father and son sharing a moment" />
              </div>
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="section section--alt reveal" id="how-it-works">
          <div className="container">
            <header className="section__header">
              <p className="eyebrow">How It Works</p>
              <h2>Three simple steps to get covered</h2>
            </header>

            <div className="steps-grid">
              <article className="step">
                <span className="step__number">1</span>
                <h3>Choose your plan</h3>
                <p>Select the level of cover and premium that best suits your needs and budget.</p>
              </article>
              <article className="step">
                <span className="step__number">2</span>
                <h3>Submit your details</h3>
                <p>Request a call-back or quote and provide your personal details to our team.</p>
              </article>
              <article className="step">
                <span className="step__number">3</span>
                <h3>Get confirmation &amp; activation</h3>
                <p>
                  Once your application is accepted and first premium is paid, your cover is
                  activated.
                </p>
              </article>
            </div>
          </div>
        </section>

      </main>

      <section className="section section--servi-banner">
        <div className="container">
          <div className="servi-banner">
            <div className="servi-banner__logo">
              <img src={ServiLogo2025} alt="Servi Contact logo" />
            </div>
            <p className="servi-banner__text">
              Ikusasalethu Group is a service owned by{' '}
              <a
                href="https://www.servi-contact.co.za/"
                target="_blank"
                rel="noreferrer"
                className="servi-banner__text-link"
              >
                Servi Contact
              </a>
              .
            </p>
          </div>
        </div>
      </section>

      <footer className="footer" id="contact">
        <div className="container footer__grid">
          <div className="footer__brand">
            <div className="logo-mark logo-mark--footer">
              <img
                src={IkusasalethuGroupLogo}
                alt="Ikusasalethu Group logo"
                className="logo-mark__img"
              />
            </div>
            <div>
              <p className="footer__brand-name">Ikusasalethu Group</p>
              <p className="footer__brand-sub">
                Funeral cover product owned and administered by Servi Contact.
              </p>
              <p className="footer__brand-sub">Established in 2014.</p>
            </div>
          </div>

          <div className="footer__cols">
            <div>
              <h4>Contact</h4>
              <ul className="footer__list">
                <li>Phone: 087 351 6645</li>
                <li>Email: info@ikusasalethugroup.co.za</li>
              </ul>
            </div>
            <div>
              <h4>Services</h4>
              <ul className="footer__list">
                <li>
                  <a href="#plans">Funeral Cover Plans</a>
                </li>
                <li>
                  <a href="#about">About Ikusasalethu Group</a>
                </li>
                <li>
                  <a href="#how-it-works">How It Works</a>
                </li>
                {/* <li>
                  <a href="#quote">Request a Quote</a>
                </li> */}
              </ul>
            </div>
            <div>
              <h4>Compliance</h4>
              <div className="footer__compliance">
                <p className="footer__compliance-line">
                  <strong>Ikusasalethu Group</strong> is a product owned and administered by Servi
                  Contact.
                </p>
                <p className="footer__compliance-line">
                  Registered Financial Services Provider · <strong>FSP 51968</strong>
                </p>
                <p className="footer__compliance-line">
                  All products are subject to terms and conditions.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <div className="container footer__bottom-inner">
            {/* <p>
              Funeral cover from as little as R79 · Family cover from R118 · Claims paid within 48
              hours
            </p> */}
            <p className="footer__copy">&copy; 2026 Ikusasalethu Group · Powered by Servi Contact</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
